import { useQuery } from "@tanstack/react-query";
import { applicationService } from "@/services/application.service";
import { SUBJECT_PERFORMANCE_STALE_MS } from "./use-subject-performance";

export function subjectPerformanceChartQueryKey(
	applicationId: string,
	subjectId: string,
) {
	return ["subjectPerformanceChart", applicationId, subjectId] as const;
}

export function useSubjectPerformanceChart(
	applicationId: string,
	subjectId: string,
) {
	return useQuery({
		queryKey: subjectPerformanceChartQueryKey(applicationId, subjectId),
		queryFn: () =>
			applicationService().getSubjectPerformanceChart(applicationId, subjectId),
		enabled: !!applicationId && !!subjectId,
		staleTime: SUBJECT_PERFORMANCE_STALE_MS,
	});
}
